import * as denotion from '../actionType/ActionTypes'


const initState = {
    rightbarOpen : false,
    rightbarType : '',
    rightbarId : '',
    rightbarFileId : '',
    currentFolder : [{id: '', name: 'Documents', level: 1}],
    searchResult: undefined,
    searchState: false,
    searchData: undefined,
    searchTrigger: false,
    document: undefined,
    allCategory: undefined,
    pendingCount: 0,
    notifyCount:false,
    archiveTrigger:false
}




const documentReducer = ( state = initState, action) => {
    switch(action.type) {
       case denotion.SET_CATEGORY_DATA :
            return {
                ...state,
                document : action.payload
            }
       case denotion.SET_ALL_CATEGORY : 
            return {
                ...state,
                allCategory : action.payload
            }
        case denotion.RIGHTBAR_OPEN :
           return {
                ...state,
                rightbarOpen : true, 
                rightbarType : action.payload[0],
                rightbarId : action.payload[1]
            }
        case denotion.RIGHTBAR_CLOSE :
            return {
                ...state,
                rightbarOpen : false,
                rightbarType : ''
            }
        case denotion.SEARCH_DATA :
            return {
                ...state,
                searchData : action.payload
            }
        case denotion.SEARCH_RESULT :
            return {
                ...state,
                searchResult : action.payload
            }
        case denotion.SEARCH_STATE :
            return {
                ...state,
                searchState : action.payload
            }
        case denotion.SEARCH_TRIGGER :
            return {
                ...state,
                searchTrigger : action.payload
            }
        case denotion.ARCHIVE_TRIGGER :
            return {
                ...state,
                archiveTrigger : !state.archiveTrigger
            }
        case denotion.PENDING_COUNT :
            return {
                ...state,
                pendingCount : action.payload
            }
        case denotion.NOTIFY_COUNT :
            return {
                ...state,
                notifyCount : !state.notifyCount
            }
            default:
                return state;
        }
}

export default documentReducer